import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import ButtonNew from '~/Common-Objects/UI/Button'
import Icon from '~/Common-Objects/UI/Icon'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import axios from '~/data/http/axios'
import i18n from '~/i18n'
import Mailchimp2Icons from '~/pages/cp/company/integrations/apps/mailchimp2/icons'
import { MAILCHIMP_APP_ID } from '~/utils/mailchimpOAuth'
import { MAILCHIMP_FLOW_PATH } from '~/pages/cp/import/paths'
import { isCompletedMailchimpImport, mailchimpImportAgainPath } from '~/pages/cp/import/mailchimpImportStatus'
import { openMailchimpFlow } from '~/pages/cp/import/mailchimpFlowOrigin'

export default function Mailchimp2ImportCta() {
    const history = useHistory()
    const [checking, setChecking] = useState(true)
    const [complete, setComplete] = useState(false)

    useEffect(() => {
        let cancelled = false
        axios
            .get('/application/account/app/' + MAILCHIMP_APP_ID)
            .then((res) => {
                if (cancelled) return
                if (res.data && res.data.error) {
                    setComplete(false)
                } else {
                    setComplete(isCompletedMailchimpImport(res.data && res.data.Application))
                }
            })
            .catch(() => {
                if (!cancelled) setComplete(false)
            })
            .finally(() => {
                if (!cancelled) setChecking(false)
            })
        return () => {
            cancelled = true
        }
    }, [])

    let actions = (
        <div className='mailchimp2-cta__actions'>
            <LoadingIcons iconType='2' style={{ width: 22, height: 22 }} />
        </div>
    )
    if (!checking) {
        actions = (
            <div className='mailchimp2-cta__actions'>
                {complete ? (
                    <>
                        <ButtonNew
                            onClick={() => openMailchimpFlow(history, MAILCHIMP_FLOW_PATH)}
                            variant='secondary'
                            size='s'
                        >
                            {i18n.t('mailchimp2:cta.view')}
                        </ButtonNew>
                        <ButtonNew
                            onClick={() => openMailchimpFlow(history, mailchimpImportAgainPath())}
                            variant='secondary'
                            size='s'
                        >
                            {i18n.t('mailchimp2:cta.importAgain')}
                        </ButtonNew>
                    </>
                ) : (
                    <ButtonNew
                        onClick={() => openMailchimpFlow(history, MAILCHIMP_FLOW_PATH)}
                        iconRight={<Icon name='arrow-right' />}
                        variant='secondary'
                        size='s'
                    >
                        {i18n.t('mailchimp2:cta.button')}
                    </ButtonNew>
                )}
            </div>
        )
    }

    return (
        <Paper className='mailchimp2-cta'>
            <Mailchimp2Icons />
            <div className='mailchimp2-cta__copy'>
                <h2 className='h6'>{i18n.t('mailchimp2:cta.title')}</h2>
                <p>{i18n.t('mailchimp2:cta.body')}</p>
            </div>
            {actions}
        </Paper>
    )
}
